import $api from '../services';

export default {
    create(params) {
        return $api.post('/coupons', params);
    },
    update(id, params) {
        return $api.put(`/coupons/${id}`, params);
    },
    read(id) {
        return $api.get(`/coupons/${id}`);
    },
    delete(id) {
        return $api.delete(`/coupons/${id}`);
    },
    list(params) {
        return $api.get('/coupons', params);
    }
};
